import axios from 'axios'
import { buildRequestBody } from '@/helpers/lists'

const enableNightAgent = ({ rootState, dispatch }, payload) => {
  const nightAgent = payload.responseCenter ? 'approve' : 'denied'
  axios.put(`${rootState.baseURL}/orgs/${payload.id}/settings/nightagent`, { value: nightAgent })
  .then((res) => {
    if (res) {
      let payload = { type: 'success', text: 'Successfully enabled NightAgent' }
      if (res.data.data.value === 'denied') {
        payload = { type: 'success', text: 'Successfully disabled NightAgent' }
      }
      dispatch('updateMessages', payload, { root: true })
    }
  })
}

const fetchList = async ({ rootState, commit }, payload) => {
  commit('setLoadingState', true, { root: true })
  commit('resetList')
  const requestBody = buildRequestBody(payload)
  await axios.post(`${rootState.baseURL}/reservations/list`, requestBody, {
  })
    .then((res) => {
      if (res) {
        commit('updateListData', res.data.data)
        commit('updatePagination', res.data.pagination)
        commit('setLoadingState', false, { root: true })
      }
    })
}

const validateCSV = async ({ rootState, commit }, payload) => {
  return await axios.post(`${rootState.baseURL}/reservations/validate`, payload, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
  }).then((response) => {
    commit('updateValidationMessage', response.data)
  })
}

const uploadCSV = async ({ rootState, dispatch }, payload) => {
  await axios.post(`${rootState.baseURL}/reservations/upload`, payload, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
  }).then((response) => {
    const messagePayload = { type: 'success', text: 'Reservations upload complete!' }
    dispatch('updateMessages', messagePayload, { root: true })
  })
}

const getCSVTemplate = ({ rootState, dispatch }, payload) => {
  axios.post(`${rootState.baseURL}/reservations/template`, payload, {
  }).then((response) => {
    const messagePayload = { type: 'success', text: 'Download Started...' }
    dispatch('updateMessages', messagePayload, { root: true })
    const blob = new Blob([response.data], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = payload.fileName || 'template'
    a.click()
    a.remove()
  })
}

const bulkDelete = async ({ rootState, state, dispatch }) => {
  const body = {
    reservations: state.listData.map(x => x.id),
  }
  await axios.delete(`${rootState.baseURL}/reservations/bulk`, { data: body }).then((response) => {
    const messagePayload = { type: 'success', text: 'All reservations deleted!' }
    dispatch('updateMessages', messagePayload, { root: true })
  })
}

const deleteReservation = async ({ rootState, state, dispatch }, payload) => {
  await axios.delete(`${rootState.baseURL}/reservations/${payload.id}`).then((response) => {
    const messagePayload = { type: 'success', text: `${payload.guestInfo}'s reservation is deleted!` }
    dispatch('updateMessages', messagePayload, { root: true })
  })
}

export default {
  enableNightAgent,
  validateCSV,
  uploadCSV,
  getCSVTemplate,
  fetchList,
  bulkDelete,
  deleteReservation,
  // fetchEscalationSettings,
  // saveEscalationSettings
}
